import { Button } from "@progress/kendo-react-buttons";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Loader } from "@progress/kendo-react-indicators";
import { FormInput } from "commons/forms/form";
import { required } from "commons/forms/validators";
import CustomModal from "commons/modal/CustomModal";
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { TOKEN, USER } from "constants/context";
import { useLoginWithCredentialsMutation } from "../../redux/api/login";
import { setToken, setUser } from "../../redux/slices/appStateSlice";
import { pubApi } from "../../redux/api/cache";

export default function ConnectionPage() {
    const [loginWithCredentials] = useLoginWithCredentialsMutation();

    const handleSubmit = async (dataItem) => {
        localStorage.removeItem('categories');
        await post(dataItem);
    };
    const dispatch = useDispatch();
    const [error, setError] = useState(undefined);
    const [isLoading, setIsLoading] = useState(undefined);

    const post = useCallback(
        async (dataItem) => {
            setIsLoading(true);
            await loginWithCredentials({ user: dataItem.user, password: dataItem.password }).unwrap().then((result) => {
                dispatch(pubApi.util.resetApiState());
                let token = result.headers.get('Authorization');
                localStorage.setItem(TOKEN, token);
                localStorage.setItem(USER, dataItem.user);
                dispatch(setToken(token));
                dispatch(setUser(dataItem.user));
                setError(undefined);
            }).catch((result) => {
                let messageErreur = result.status === 401 ? "Les identifiants sont invalides!" : "La connexion a échoué!";
                setError(messageErreur);
                setIsLoading(false);
            });
        },
        [dispatch, loginWithCredentials]
    );

    const userValidator = (e) => required(e, 'Utilisateur');
    const passwordValidator = (e) => required(e, 'Mot de passe');

    return (
        <CustomModal
            closeIcon={false}
            width={'400px'}
            title="Connexion"
            body={
                isLoading ? (
                    <div style={{ height: '300px' }}>
                        <div className="d-flex justify-content-center">
                            <Loader
                                style={{ marginTop: '100px' }}
                                size={'large'}
                                type={'infinite-spinner'}
                            />
                        </div>
                    </div>
                ) : (
                    <Form
                        onSubmit={handleSubmit}
                        render={(formRenderProps) => (
                            <FormElement>
                                {error !== undefined && (
                                    <blockquote className="custom-blockquote error-sm ">
                                        <p style={{ marginBottom: '0px' }}>{error}</p>
                                    </blockquote>
                                )}
                                <fieldset className={'k-form-fieldset'}>
                                    <Field
                                        id={'user'}
                                        name={'user'}
                                        label={'Utilisateur'}
                                        component={FormInput}
                                        validator={userValidator}
                                    />
                                    <Field
                                        id={'password'}
                                        name={'password'}
                                        label={'Mot de passe'}
                                        type={'password'}
                                        component={FormInput}
                                        validator={passwordValidator}
                                    />
                                    <div className="k-form-buttons">
                                        <Button
                                            type={'submit'}
                                            className="blueButton"
                                            disabled={!formRenderProps.allowSubmit}
                                        >
                                            Se connecter
                                        </Button>
                                    </div>
                                </fieldset>
                            </FormElement>
                        )}
                    />
                )
            }
        />
    );
}